// Indian States + Union Territories (as of 2026)
export const INDIA_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  // Union Territories
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

// Major cities per state — used for the City dropdown.
// For now only Uttar Pradesh is unlocked in the UI; other entries reserved for the future.
export const CITIES_BY_STATE = {
  "Uttar Pradesh": [
    "Gorakhpur",
    "Lucknow",
    "Kanpur",
    "Varanasi",
    "Agra",
    "Prayagraj",
    "Meerut",
    "Ghaziabad",
    "Noida",
    "Bareilly",
    "Aligarh",
    "Moradabad",
    "Saharanpur",
    "Jhansi",
    "Ayodhya",
    "Mathura",
    "Firozabad",
    "Muzaffarnagar",
    "Rae Bareli",
    "Sultanpur",
    "Basti",
    "Deoria",
    "Gonda",
    "Ballia",
    "Azamgarh",
  ],
  "Maharashtra": [
    "Pune",
    "Mumbai",
    "Nagpur",
    "Nashik",
    "Aurangabad",
    "Solapur",
    "Kolhapur",
    "Amravati",
  ],
};

export const DEFAULT_STATE = "Uttar Pradesh";
export const DEFAULT_CITY = "Gorakhpur";
